<template>
  <div>
    <el-dialog
      :title="form.isCreate ? '添加模板' : '修改模板'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="710px"
    >
      <el-form ref="form" :model="form" label-width="200px" size="mini">
        <el-form-item label="名称：" prop="name">
          <el-input
            v-model="form.name"
            placeholder="用于区分不同的模板"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="道具：" prop="props">
          <attachment
            v-for="item of attachments"
            :key="item.seq"
            :availableAttachments="availableAttachments"
            v-model="item.data"
            @remove="removeAttachment(item.seq)"
            nameWidth="300px"
          ></attachment>
          <el-button @click="addAttachment()" class="el-icon-plus"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");

import Attachment from "./components/PropsAttachment.vue";

// 本弹窗名称
const DialogName = "EditMailPropsTemplateDialog";

export default {
  data() {
    return {
      form: {
        isCreate: true,
        name: "",
        props: [],
      },
      attachments: [],
      availableAttachments: [],
      attachmentSeq: 0,
    };
  },
  components: {
    Attachment,
  },

  async created() {
    let value = this.$dialogutil.getData(DialogName);

    this.form.isCreate = value.isCreate;

    if (!this.form.isCreate) {
      this.form.id = value.entry.id;
      this.form.name = value.entry.name;
      this.form.props = value.entry.props;
    }

    await this.loadAvailableAttachments();
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.form.name = this.form.name.trim();
      if (this.form.name.length == 0) {
        this.$message({
          message: "名称不能为空",
          type: "error",
        });
        return;
      }

      let props = [];

      for (let e of this.attachments) {
        if (e.data.valuesOfNodes.length == 0) {
          this.$message({
            message: "请正确选择奖励",
            type: "error",
          });
          return;
        }

        let id = e.data.valuesOfNodes[1];
        let amount = e.data.number;
        if (amount == 0) {
          this.$message({
            message: "奖励数量不能为0",
            type: "error",
          });
          return;
        }
        props.push({
          id: id,
          amount: amount,
        });
      }

      if (props.length == 0) {
        this.$message({
          message: "奖励不能为空",
          type: "error",
        });
        return;
      }

      this.form.props = props;

      if (this.form.isCreate) {
        this.add();
      } else {
        this.update();
      }
    },

    /**
     * 新增
     */
    async add() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增附件？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/addMailPropsTemplate`,
            {
              name: this.form.name,
              props: JSON.stringify(this.form.props),
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        // 弹确认框
        await this.$confirm(`添加成功`, { showCancelButton: false });

        // 关闭当前对话框
        this.onClose();
      } catch (e) {}
    },

    /**
     * 修改
     */
    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改附件？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/updateMailPropsTemplate`,
            {
              id: this.form.id,
              name: this.form.name,
              props: JSON.stringify(this.form.props),
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose();
      } catch (e) {}
    },

    /**
     * 查询可用附件集合
     */
    async loadAvailableAttachments() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: false,
          },
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      for (let category of resData.data.categories) {
        this.availableAttachments.push({
          label: category.name,
          value: category.name,
          children: (() => {
            let result = [];
            for (let e of category.entries) {
              result.push({
                label: e.name,
                value: e.id,
              });
              if (!this.form.isCreate) {
                for (let item of this.form.props) {
                  if (item.id == e.id) {
                    this.attachments.push({
                      seq: ++this.attachmentSeq,
                      data: {
                        valuesOfNodes: [category.name, e.id],
                        number: item.amount,
                      },
                    });
                  }
                }
              }
            }
            return result;
          })(),
        });
      }
    },

    /**
     * 增加一个附件
     */
    addAttachment() {
      this.attachments.push({
        seq: ++this.attachmentSeq,
        data: {
          valuesOfNodes: [],
          number: 1,
        },
      });
    },

    /**
     * 删除一个附件
     */
    removeAttachment(seq) {
      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].seq == seq) {
          this.attachments.splice(i, 1);
          break;
        }
      }
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>